$(document).ready(function(){
    
    //Sanfona - perguntas frequentes
    $('.box a').click(function() {
        $('.content-resposta').slideUp();
        if ($(this).attr('class') != 'ativo') {
            $('.box a').removeClass('ativo');
            $(this).addClass('ativo');
            $(this).next().slideDown();
        } else {
            $(this).next().slideUp();
            $(this).removeClass('ativo');
        }
    });  
    
    
    $('body#members-club a[href^="#"]').on('click', function(e) {
        e.preventDefault();
        var id = $(this).attr('href'),
                targetOffset = $(id).offset().top;
                
        $('html, body').animate({ 
            scrollTop: targetOffset - 100
        }, 500);
    });

   
    if($('.col-left.item-1')){
        var value = $(this).find('#valores').val();
        var valueTotal = 0;
        valueTotal = value / 12;
        $('.col-left.item-1 .price-anual span strong').text('R$'+ valueTotal);
    }

    if($('.col-left.item-2')){
        var value = $('.col-left.item-2').find('#valores').val();
        $('.col-left.item-2 .price-anual span strong').text('R$'+ value);
    }

});

// function validCart(){
//     $(document).on('click','#addCustomCart', function(e) {
//         e.preventDefault();
       
//         $.ajax({
//             url: '/cart.js',
//             type: 'GET',
//             dataType: 'json',
//             success: function(response){
                
//                 let produtoNormal = false
//                 let produtoRecorrencia = false
        
//                 for ( let i = 0; i < response.items.length; i++ ) {
    
//                     if( response.items[i].properties != null && response.items[i].properties.recorrencia ){
//                         produtoRecorrencia = true
//                     }else{
//                         produtoNormal = true
//                     }
//                 }
    
//                 if(produtoNormal && produtoRecorrencia){
//                     Swal.fire({
//                         icon: 'error',
//                         customClass: "modal-recorrencia",
//                         width:"450px",
//                         text: 'Não é possível comprar produtos de assinatura e da loja no mesmo carrinho, remova uma das opções para prosseguir com a compra'           
//                     });
//                     return false;
//                 }else{
//                     $('.cart__checkout').click();
//                 }
            
//             },
//             error: function(error){
//                 console.log('ERROR', error);
//             }
//         });
    
//     });
// }

//Verifica se tem o opencart-true na url e abre o mini cart
setTimeout( () => {
    if (window.location.href.indexOf("opencart=true") > -1) {
        $('.site-header__cart-toggle i').trigger('click')     
    }
},1000);
   
$(document).on('click', '#addCustomProduct', function(){                
    debugger
    
    var valueID = $(this).val();
    var assinatura = $(this).parent().find('#assinatura').val();
    var periodicidade = $(this).parent().find('#periodicidade').val();

    $(this).closest('.btnCustom').find('.loading').addClass('is-loading');

    var addItens = [];

    addItens.push({
        id: valueID,
        quantity: 1,
        properties: {
            Assinatura: assinatura,
            Periodicidade: periodicidade
        }
    }) 

    $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: {items: addItens},
        success: function(cart){
            console.log('Results', cart);

            //$('.site-header .site-header__cart-toggle').load(window.location.href + " " + ' .site-header .site-header__cart-toggle > *');
            $('.btnCustom').find('.loading').removeClass('is-loading');
            if (window.location.href.indexOf("opencart=true") > -1) {
                setTimeout(() => {
                    document.location.reload(true);
                }, 1000);
            }else{
                if (window.location.href.indexOf("?") > -1) {
                    setTimeout(() => {
                        window.location.href += "&opencart=true";
                    }, 1000);
                }else{
                    setTimeout(() => {
                        window.location.href += "?opencart=true";
                    }, 1000);
                }
            } 
        },
        error: function(error){
            console.log('Erro de requisição', error);
        }
    });

});    


setTimeout(function(){
    //validCart();

    $('.js-drawer-close').on('click', function(){
        window.history.pushState('data', 'marina-shore', window.location.href.split("?")[0]);
        // $('.site-header .site-header__cart-toggle').load(window.location.href + " " + ' .site-header .site-header__cart-toggle > *');
    });


},2000);

